var pilotfront = {};
pilotfront.formToJs = function (form) {
	var o = {};
	var a = form.serializeArray();

	$.each(a, function () {
		if (o[this.name] !== undefined) {
			if (!o[this.name].push) {
				o[this.name] = [o[this.name]];
			}
			o[this.name].push(this.value || '');
		} else {
			o[this.name] = this.value || '';
		}
	});

	return o;
};

pilotfront.jsToJson = function (js) {
	return JSON.stringify(js);
};

pilotfront.number_format = function (number, decimals, dec_point, thousands_sep) {
	number = (number + '')
		.replace(/[^0-9+\-Ee.]/g, '');
	var n = !isFinite(+number) ? 0 : +number,
		prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
		sep = (typeof thousands_sep === 'undefined') ? '.' : thousands_sep,
		dec = (typeof dec_point === 'undefined') ? ',' : dec_point,
		s = '',
		toFixedFix = function (n, prec) {
			var k = Math.pow(10, prec);
			return '' + (Math.round(n * k) / k)
					.toFixed(prec);
		};
	// Fix for IE parseFloat(0.55).toFixed(0) = 0;
	s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
		.split('.');
	if (s[0].length > 3) {
		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	}
	if ((s[1] || '')
			.length < prec) {
		s[1] = s[1] || '';
		s[1] += new Array(prec - s[1].length + 1)
			.join('0');
	}
	return s.join(dec) + ',-';
};


// == SETTINGS ==
pilotfront.settings = {};
pilotfront.settings.baseUrl = '/_/moya/pilotfront/ajax/';
pilotfront.settings.getUrl = function(endpoint) {
	return '/_/' + moya.division + '/pilotfront/ajax/' + endpoint;
};

// == UI ==

pilotfront.ui = {};
pilotfront.ui.init = function () {
	pilotfront.ui.bindTogglePaymentMethod();
};

pilotfront.ui.child = {};
pilotfront.ui.child.openOptions = function (id) {
	var $options = $('.options.child-' + id, '#pilotfront');
	var $tile = $options.parents('.tile');
	var $size = $tile.find('.sizes.child-' + id);
	var doOpen = ($options.hasClass('open')) ? false : true;

	pilotfront.ui.child.closeOptions();

	if (doOpen) {
		$tile.addClass('open');
		$size.addClass('open');
		$options.addClass('open');
	}

	return false;
};

pilotfront.ui.child.closeOptions = function () {
	$('.tile', '#pilotfront').each(function () {
		var $tile = $(this);
		var $other = $tile.find('.open:not(.extra)');

		$tile.removeClass('open');
		$other.removeClass('open');
	});

	return false;
};


pilotfront.ui.product = {};

pilotfront.ui.product.openOptions = function (btn) {
	var $btn = $(btn);
	var $tile = $btn.parents('.tile');
	var $options = $tile.find('.options');
	var $cart = $tile.find('.ui-addcart');
	var doOpen = ($tile.hasClass('open')) ? false : true;

	pilotfront.ui.product.closeOptions();

	if (doOpen) {
		$tile.addClass('open');
		$options.addClass('open');
		$btn.addClass('btn-hide');
		$cart.removeClass('btn-hide');

		// If there is only one quantity field, open it too
		if ($options.find('.groups').length === 1) {
			$options.find('.groups.quantity > .items.main').addClass('open');
		}
	}

	return false;
};

pilotfront.ui.product.closeOptions = function () {
	$('.tile', '#pilotfront').each(function () {
		var $tile = $(this);
		var $options = $tile.find('.options:not(.extra)');
		var $btn = $tile.find('.ui-options');

		$tile.removeClass('open');
		$options.removeClass('open');
		$btn.removeClass('btn-hide');
		if ($btn.length) {
			$tile.find('.ui-addcart').addClass('btn-hide');
		}
	});

	return false;
};

pilotfront.ui.product.openGroup = function (btn) {
	var $items = $(btn).parent('.itemslabel').next();
	var isOpen = $items.hasClass('open');

	pilotfront.ui.product.closeGroups();

	if (!isOpen) {
		$items.addClass('open');
	}

	return false;
};

pilotfront.ui.product.closeGroups = function () {
	$('.groups .items.open:not(.extra)', '#pilotfront').each(function () {
		$(this).removeClass('open');
	});

	return false;
};

pilotfront.ui.openCart = function () {
	var $cart = $('#pilotfrontCartMain');

	if ($cart.hasClass('open')) {
		$cart.removeClass('open');
	}
	else {
		$cart.addClass('open');
	}

	return false;
};

pilotfront.ui.closeCart = function () {
	var $cart = $('#pilotfrontCartMain');
	$cart.removeClass('open');
};

pilotfront.ui.priceRefresh = function (tile) {
	//console.log('call: ui.priceRefresh');

	var $tile = $(tile),
		$tabs = $tile.find('.ui-tabs-panel:not(.splitpanel)'),
		items = {},
		increase = 0;

	if ($tabs.length === 0) {
		$tabs = $tile;
	}
	// Loop through quantities
	$tabs.each(function(tabId) {
		var $tab = $(this),
			split = false,
			included = null,
			$quantityGroups = $tab.find('.groups.quantity');

		$quantityGroups.each(function (groupIndex) {
			var $group = $(this),
				part = parseInt($group.find('input.part').val()) || 0,
				mod = 1;

			split = ($group.parents('.split').find('.splittabs').length);
			if (split) {
				mod = 2;
			}
			else {
				included = null;
			}

			if (included === null) {
				included = parseInt($group.find('input.included').val()) * mod;
			}

			// Loop through all item groups
			$group.find('.items').each(function (i) {
				var $items = $(this),
					groupId = i,
					groupImpact = parseInt($items.find('> input.priceImpact').val());

				// Loop through selected values and create an item array
				$items.find('input.qty').each(function () {
					var $item = $(this),
						quantity = parseInt($item.val()),
						itemId = $item.siblings('.itemId').val(),
						itemImpact = $item.siblings('.priceImpact').val();

					if (quantity > 0) {
						if (!items[tabId]) {
							items[tabId] = {
								groups: {}
							};
						}

						if (!items[tabId].groups[groupIndex]) {
							items[tabId].groups[groupIndex] = {
								included: included,
								options: {},
							};
						}
						if (!items[tabId].groups[groupIndex].options[groupId]) {
							items[tabId].groups[groupIndex].options[groupId] = {
								id: groupId,
								priceImpact: groupImpact,
								split: split,
								items: {}
							};
						}

						if (!items[tabId].groups[groupIndex].options[groupId].items[itemId]) {
							items[tabId].groups[groupIndex].options[groupId].items[itemId] = {
								id: itemId,
								priceImpact: itemImpact ? itemImpact : 0
							};
						}

						if (!items[tabId].groups[groupIndex].options[groupId].items[itemId].selected) {
							items[tabId].groups[groupIndex].options[groupId].items[itemId].selected = [0];
						}

						items[tabId].groups[groupIndex].options[groupId].items[itemId].selected[part] = quantity;
					}
				});
			});
		});

		$tile.find('.groups.checkbox .checkbox').each(function () {
			var $this = $(this);
			if ($this.find('input').is(':checked')) {
				var itemImpact = parseInt($this.find('.itemPriceImpact').val()),
					groupImpact = parseInt($this.siblings('.groupPriceImpact').val());
				increase += itemImpact ? itemImpact : groupImpact;
			}
		});
	});

	// parse the item array to calculate total price like the backend
	$.each(items, function(xTabid, xTab) {
		$.each(xTab.groups, function(xGroupIndex, xOptions) {
			$.each(xOptions.options, function(xGroupId, xGroup) {
				$.each(xGroup.items, function(xItemId, xItem) {
					if (xItem && xItem.selected) {
						var xGroupImpact = xGroup.priceImpact;
						$.each(xItem.selected, function(xPart, xQuantity) {
							var xItemImpact = xItem.priceImpact;
							xOptions.included -= xQuantity;
							if (xOptions.included < 0) {
								xImpact = xItemImpact ? xItemImpact : xGroupImpact;
								if (xGroup.split) {
									xImpact = xImpact / 2;
								}
								increase += xImpact * Math.abs(xOptions.included);
								// Since we have used up included we reset it to zero before checking the next group
								xOptions.included = 0;
							}
						});
					}
				});
			});
		});
	});

	if (increase == 0) {
		increase = '';
	}
	else {
		increase = '+ ' + pilotfront.number_format(increase);
	}

	$tile.find('.price .increase').html(increase);
};

pilotfront.ui.quantityRefresh = function () {
	//console.log('call: ui.quantityRefresh');

	//update optionGroup totals
	$('.tile.open', '#pilotfront').each(function () {
		var $tile = $(this);

		$tile.find('.groups.quantity').each(function () {
			var $group = $(this);

			$group.find('.items').each(function () {
				var groupcount = 0;
				var $items = $(this);

				$items.find('input.qty').each(function () {
					groupcount += parseInt($(this).val());
				});

				$items.prev().find('span.count').html('(' + groupcount + ')');
			});
		});
	});

	//update cart total
	var cartTotal = 0;
	$('input', '#pilotfrontCartMain').each(function () {
		cartTotal += parseInt($(this).val());
	});
	if (cartTotal) {
		$('.title .count', '#pilotfrontCartMain').html('(' + cartTotal + ')');
	}

	return false;
};

pilotfront.ui.quantityDown = function (btn) {
	//console.log('call: ui.quantityDown');

	var $quantity = $(btn).parent('.quantity'),
		$span = $quantity.find('.count'),
		$input = $quantity.find('input.qty'),
		count = parseInt($input.val());

	if (count > 0) {
		$input.val(--count);
		if ($span.length) {
			$span.html(count);
		}

		if (count == 0) {
			$span.removeClass('selected');
		}
	}

	pilotfront.ui.quantityRefresh();
	pilotfront.ui.priceRefresh($quantity.parents('.tile'));

	// Update cart if we are updating quantity there
	if ($quantity.parents('#pilotfrontCartMain').length) {
		pilotfront.cart.updateQuantity();
	}

	return false;
};

pilotfront.ui.quantityUp = function (btn) {
	//console.log('call: ui.quantityUp');

	var $quantity = $(btn).parent('.quantity'),
		$group = $quantity.parents('.groups'),
		$span = $quantity.find('.count'),
		$input = $quantity.find('input.qty'),
		$max = $group.find('input.max'),
		max = ($max.length) ? parseInt($max.val()) : null,
		count = parseInt($input.val()),
		groupcount = 0;

	$input.each(function () {
		groupcount += parseInt($(this).val());
	});

	if ((max && count <= max && groupcount < max) || (max == null && count < 99)) {
		$input.val(++count);
		$span.html(count).addClass('selected');
	}

	pilotfront.ui.quantityRefresh();
	pilotfront.ui.priceRefresh($group.parents('.tile'));

	// Update cart if we are updating quantity there
	if ($quantity.parents('#pilotfrontCartMain').length) {
		pilotfront.cart.updateQuantity();
	}

	return false;
};

pilotfront.ui.productRefresh = function (btn) {
	var $btn = $(btn);
	var $tile = $btn.parents('.tile');
	var $form = $tile.find('form');
	var id = $form.find('input[name=id]').val();
	var categoryId = $form.find('input[name=categoryId]').val();

	$.ajax({
		url: pilotfront.settings.getUrl('productrefresh'),
		type: 'get',
		data: {
			id: id,
			categoryId: categoryId
		},
		dataType: 'html',
		success: function (r) {
			$('#tile-product-' + id).replaceWith(r);
			$(".tabs").tabs();
		}
	});

	return false;
};

pilotfront.ui.productSplit = function (btn) {
	var $btn = $(btn);
	var $index = $btn.prev('input');
	var $tile = $btn.parents('.tile');
	var $form = $btn.parents('form');

	var data = pilotfront.formToJs($form);
	data.index = $index.val();

	$.ajax({
		url: pilotfront.settings.getUrl('productsplit'),
		type: 'post',
		data: data,
		success: function (r) {
			$btn.parents('.split').html(r);
			pilotfront.ui.priceRefresh($tile);
		}
	});

	return false;
};

pilotfront.ui.bindTogglePaymentMethod = function () {
	$('input.radio', '#elm_paymentMethod').on('input', function(event) {
		$('fieldset.paymentMethod', '#pilotfront').removeClass('show');

		var paymentMethodId = event.target.value;
		$('fieldset[rel="'+paymentMethodId+'"].paymentMethod', '#pilotfront').addClass('show');
	});
	$('input.radio:checked', '#elm_paymentMethod').trigger('input');
};

// == QUICKORDER ==
pilotfront.quickorder = {};
pilotfront.quickorder.dialog = null;
pilotfront.quickorder.form = null;

pilotfront.quickorder.init = function() {
	pilotfront.quickorder.createForm();
	pilotfront.quickorder.createDialog();
};

pilotfront.quickorder.createForm = function() {
	pilotfront.quickorder.form = $('#quickorderForm');

	if (!pilotfront.quickorder.form.length) {
		var html = "<form id='quickorderForm'>" +
			"<label for='name'>Nafn</label><br />" +
			"<input type='text' name='name' id='quickorderName' class='text ui-widget-content ui-corner-all' style='width:320px'/><br />" +
			"<label for='extra'>Athugasemd</label><br />" +
			"<textarea name='extra' id='quickorderExtra' class='text ui-widget-content ui-corner-all' style='width:320px'></textarea>" +
			"</form>";

		$('body').append(html);
	}
};

pilotfront.quickorder.createDialog = function() {
	pilotfront.quickorder.dialog = $('#quickorderForm').dialog({
		modal: true,
		title: 'Upplýsingar frá viðskiptavin',
		width: 360,
		buttons: {
			'Hætta við': function() {
				pilotfront.quickorder.dialog.dialog('close');
			},
			'Vista': pilotfront.quickorder.submitForm
		},
		close: function() {
			$('#quickorderName').val('');
			$('#quickorderExtra').val('');
		},
		focus: function() {
			pilotfront.quickorder.form.find('#quickorderName').focus();
		}
	});
};

pilotfront.quickorder.submitForm = function() {
	var $this = $('#cartQuickOrder'),
		name = $('#quickorderName').val();
		extra = $('#quickorderExtra').val();

	if (name) {
		$.ajax({
			url: $this.attr('href'),
			type: 'POST',
			data: {
				customerName: name,
				extra: extra
			},
			success: function (r) {
				if (r === 'success') {
					pilotfront.cart.refresh();
					pilotfront.quickorder.dialog.dialog('close');
					window.alert('Pöntun vistuð');
				}
				else {
					window.alert(r);
				}
			}
		});
	}
	else {
		window.alert('Nafn vantar!');
		pilotfront.quickorder.form.find('#quickorderName').focus();
	}
};

// == CART ==

pilotfront.cart = {};

pilotfront.cart.init = function () {
	var cartMain = $('#pilotfrontCartMain');

	cartMain.find('.coupon a').on('click', function (e) {
		e.preventDefault();
		pilotfront.cart.coupon($(this).siblings('#coupon').val());
	});

	cartMain.find('.coupon input').on('keyup', function (e) {
		if (e.keyCode == 13) {
			e.preventDefault();
			pilotfront.cart.coupon($(this).val());
		}
	});

	cartMain.find('#cartQuickOrder').on('click', function (e) {
		e.preventDefault();
		pilotfront.quickorder.init();

		/*
		var $this = $(this);
		var name = window.prompt('Nafn viðskiptavinar');
		if (name) {
			$.ajax({
				url: $this.attr('href'),
				type: 'POST',
				data: {customerName: name},
				success: function (r) {
					if (r === 'success') {
						pilotfront.cart.refresh();
					}
					else {
						window.alert(r);
					}
				}
			});
		}
		else {
			window.alert('Nafn vantar!');
		}
		*/
	});
};

pilotfront.cart.post = function (btn) {
	pilotfront.ui.product.closeOptions();
	pilotfront.ui.child.closeOptions();

	var $form = $(btn).parents('form');

	$.ajax({
		url: pilotfront.settings.getUrl('cartpost'),
		type: 'post',
		data: pilotfront.formToJs($form),
		success: function () {
			pilotfront.ui.productRefresh(btn);
			pilotfront.cart.refresh();
			pilotfront.cart.highlight();
		}
	});

	return false;
};

pilotfront.cart.edit = function (index) {
	$.ajax({
		url: pilotfront.settings.getUrl('cartedit'),
		type: 'get',
		data: {index: index},
		dataType: 'json',
		success: function (r) {
			if (typeof r.id != 'undefined') {
				pilotfront.ui.closeCart();

				var $tile = $('#' + r.id);
				$tile.replaceWith(r.html);

				var $newTile = $('#' + r.id);
				$newTile.find('a.ui-options').trigger('click');
				location.href = '#' + r.id;
			}
		}
	});

	return false;
};

pilotfront.cart.updateQuantity = function () {
	//console.log('call: cart.updateQuantity');

	var $form = $('form', '#pilotfrontCartMain');

	$.ajax({
		url: pilotfront.settings.getUrl('cartquantity'),
		type: 'post',
		data: pilotfront.formToJs($form)
	}).done(function () {
		pilotfront.cart.refresh(true);
	});

	return false;
};

pilotfront.cart.refresh = function (open) {
	$.ajax({
		url: pilotfront.settings.getUrl('cartrefresh'),
		type: 'get',
		data: {open: open}
	}).done(function (r) {
		$('#pilotfrontCart').replaceWith(r);
	});

	return false;
};

pilotfront.cart.clear = function () {
	if (confirm("\xDEetta mun t\xE6ma k\xF6rfuna.\nErtu viss?")) {
		$.ajax({
			url: pilotfront.settings.getUrl('cartclear'),
			type: 'get',
			success: function (r) {
				$('#pilotfrontCart').replaceWith(r);
			}
		});
	}

	return false;
};
pilotfront.cart.highlight = function () {
	$('body').animate({scrollTop: 0}, '250', 'swing', function () {
		$cart = $('#pilotfrontCartMain');
		$cart.addClass('hi');
		setTimeout(function () {
			$cart.removeClass('hi');
			setTimeout(function () {
				$cart.addClass('hi');
				setTimeout(function () {
					$cart.removeClass('hi');
				}, 250);
			}, 250);
		}, 250);

		$toggle = $('#pilotfrontCartToggle');
		$toggle.addClass('hi');
		setTimeout(function () {
			$toggle.removeClass('hi');
			setTimeout(function () {
				$toggle.addClass('hi');
				setTimeout(function () {
					$toggle.removeClass('hi');
				}, 250);
			}, 250);
		}, 250);
	});

	return false;
};

pilotfront.cart.coupon = function (couponCode) {
	$.ajax({
		url: pilotfront.settings.getUrl('coupon'),
		type: 'post',
		data: {coupon: couponCode}
	}).done(function(response) {
		if (response !== 'success') {
			$('#couponError').remove();
			var error = '<div id="couponError">'+response+'</div>';
			$('.couponCode', '#pilotfrontCartMain').append(error);
		}
		else {
			pilotfront.cart.refresh(true);
		}
	});
};


// == WAIT ==

pilotfront.wait = {};

pilotfront.wait.init = function () {
	setInterval(pilotfront.wait.refresh, 120000);
};

pilotfront.wait.refresh = function () {
	$.ajax({
		url: pilotfront.settings.getUrl('waitrefresh'),
		type: 'get',
		success: function (r) {
			$('#pilotfrontWait').replaceWith(r);
		}
	});
};


// == INIT ==

pilotfront.ui.init();
pilotfront.cart.init();
pilotfront.wait.init();
